document.addEventListener("alpine:init", () => {
  Alpine.data("CollectionATCHandler", () => ({
    loading: false,

    init() {
      this.setupATCButtonListeners();
    },

    setupATCButtonListeners() {
      document.addEventListener('click', async (event) => {
        let button = null;
        
        if (event.target.matches('.quick-add-button, .quick-add-button-desktop')) {
          button = event.target;
        } else if (event.target.closest('.quick-add-button, .quick-add-button-desktop')) {
          button = event.target.closest('.quick-add-button, .quick-add-button-desktop');
        }
        
        if (button) {
          event.preventDefault();
          event.stopPropagation();

          if (button.hasAttribute('data-disabled')) {
            return;
          }
          
          await this.handleQuickATC(button);
        }
      });
    },

    async handleQuickATC(button) {
      if (this.loading) return;
      
      try {
        this.loading = true;
        this.showLoading(button);
        
        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) {
          console.error('Variant ID not found in button');
          return;
        }

        const quantity = 1;

        if (Alpine.store("cart")) {
          await Alpine.store("cart").add({
            id: variantId,
            quantity: quantity,
          });
        }

      } catch (error) {
        console.error('Error adding to cart:', error);
      } finally {
        this.loading = false;
        this.hideLoading(button);
      }
    },

    showLoading(button) {
      const text = button.querySelector('.button-text');
      const spinner = button.querySelector('.button-spinner');
      
      if (text) text.classList.add('hidden');
      if (spinner) spinner.classList.remove('hidden');
    },

    hideLoading(button) {
      const text = button.querySelector('.button-text');
      const spinner = button.querySelector('.button-spinner');
      
      if (text) text.classList.remove('hidden');
      if (spinner) spinner.classList.add('hidden');
    },
  }));
});